/*
 * Copyright (c)2023. J <info_together@aliyun.com> All Rights Reserved.
 */

import qs from 'query-string';
import { XIAKE_APP_ID } from '@/constants/digitalHuman';

const addExtraInfoInterceptors = {
  onFulfilled: (config: any) => {
    const timestamp = Date.now();
    config.params = {
      ...config.params,
      _t: timestamp,
    };

    return config;
  },
  onRejected: () => {}
};

export default addExtraInfoInterceptors;
